/**
 * @module lang
 * 言語設定状態管理
 */

const state = {
  selectedLang: 'ja',
  list: [
    'en',
    'ja'
  ]
}

const getters = {
  selectedLang: state => state.selectedLang,
  list: state => state.list
}

const mutations = {
  SET_LANG(state, val) {
    state.selectedLang = val
  }
}

const actions = {
  setLang({ commit }, val) {
    commit('SET_LANG', val)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
